export default {
    methods: {
        generateTeamIdFromName: function(name) {
            let id = '';
            for (let c of name.toLowerCase()) {
                if (isLetterOrDigit(c)) {
                    id += c;
                } else {
                    id += '_';
                }
            }
            return id;
        }
    }
}

function isLetterOrDigit(lowerCaseChar) {
    return ('0123456789abcdefghijklmnopqrstuvwxyz'.includes(lowerCaseChar));
}
